import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const BASE_QUERY_KEY = 'insurancePolicy/contactRenewalPolicies';

/**
 * Fetches renewing policies grouped by contact ID for the UpcomingPolicyRenewals flow.
 * Uses the same request shape as the filter endpoint (ResourceSelectorContactsByOwnerRequest).
 * Call this after the recipients list loads or when policy filters change.
 *
 * Response is a dictionary: { [contactId: string]: ISparsePolicy[] }
 */
export function useContactRenewalPolicies({
	request,
	resourceSelector = Api.ResourceSelectorId.UpcomingPolicyRenewals,
	enabled = true,
}: {
	request?: Api.IResourceSelectorContactsByOwnerRequest;
	resourceSelector?: Api.ResourceSelectorId;
	enabled?: boolean;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!request,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IContactRenewalPoliciesMap>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `contact/resourceSelector/${encodeURIComponent(resourceSelector)}/policies`,
				}),
				'POST',
				request
			);
		},
		queryKey: [BASE_QUERY_KEY, resourceSelector, JSON.stringify(request)],
		refetchOnWindowFocus: false,
	});
}
